import type { Feature } from '@luna/gatekeeper';

export const installments: Feature = {
    enabled: false,
    _description: 'Enables display of the installments page for credit cards and current accounts',
};
